export default __webpack_public_path__ + "static/media/dwarf.da217872.jpg";